import React, { useEffect, useState } from "react";
import { DocIndex, loadManifest } from "../../docs/loader";
import { Link, useParams } from "react-router-dom";

const DocsLanding: React.FC = () => {
  const [items, setItems] = useState<DocIndex[]>([]);
  const { lang = "en" } = useParams();
  useEffect(() => {
    loadManifest().then(setItems).catch(console.error);
  }, []);

  const bySection: Record<string, DocIndex[]> = {};
  for (const it of items) {
    if (!bySection[it.section]) bySection[it.section] = [];
    bySection[it.section].push(it);
  }

  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Documentation</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {Object.keys(bySection).map((section) => (
          <div key={section} className="border rounded-lg p-4">
            <h2 className="text-lg font-semibold mb-2">
              {section.replace(/-/g, " ")}
            </h2>
            <ul className="space-y-1 text-sm">
              {bySection[section].slice(0, 6).map((it) => (
                <li key={it.slug}>
                  <Link
                    className="text-primary hover:underline dark:text-slate-400"
                    to={`/${lang}/docs/${it.slug}`}
                  >
                    {it.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DocsLanding;
